// #region Global Imports
import * as React from 'react';
import { useRouter } from 'next/router';
// #endregion Global Imports
// #region Local Imports
import { Icon } from '@components/Icon';
import styles from './Tools.module.sass';
// #endregion Local Imports
export const Print: React.FC<{ termPrint: string }> = ({ termPrint }) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <a
      className={styles.Post__tool}
      onClick={(event): void => {
        window.print();
        event.preventDefault();
      }}
    >
      <span className={styles.Post__tool_icon}>
        <Icon icon="print" inline />
      </span>
      {termPrint || 'Print'}
    </a>
  );
};

export const PDF: React.FunctionComponent = () => {
  const router = useRouter();
  const { asPath, locale } = router;
  const [data, setData] = React.useState('');
  const [clicked, setClicked] = React.useState(false);

  return (
    <>
      {!clicked ? (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <a
          className={styles.Post__tool}
          onClick={(event): void => {
            void (async (): Promise<void> => {
              event.preventDefault();
              setClicked(true);
              const res = await fetch(
                `${process.env.NEXT_PUBLIC_PUPPETEER_ENDPOINT}/?lang=${locale!}&article=${asPath.replace(
                  /\//g,
                  '',
                )}`,
                {
                  credentials: 'include',
                },
              );

              const buffer = await res.arrayBuffer();
              const blob = new Blob([buffer], { type: 'application/pdf' });
              setData(window.URL.createObjectURL(blob));
            })();
          }}
        >
          <span className={styles.Post__tool_icon}>
            <Icon icon="download" inline />
          </span>
          {locale === 'de' ? 'PDF vorbereiten' : 'Préparer le PDF'}
        </a>
      ) : (
        <a
          className={styles.Post__tool}
          download={asPath.concat('.pdf')}
          href={data}
          style={
            data === ''
              ? {
                pointerEvents: 'none',
                opacity: '0.4',
              }
              : {}
          }
        >
          <span className={styles.Post__tool_icon}>
            <Icon icon="download" inline />
          </span>
          {locale === 'de' ? 'PDF Herunterladen' : 'Télécharger le fichier PDF'}
        </a>
      )}
    </>
  );
};
